// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1CJsm","alertIcon":"ConfirmModal_alertIcon__1Af9j"};